module.exports = __webpack_public_path__ + "static/media/HeartFoundation.2768c0a4.jpeg";